import { render } from "./accordion.vue?vue&type=template&id=27b28f4c&scoped=true&ts=true"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"

import "./accordion.vue?vue&type=style&index=0&id=27b28f4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b28f4c"]])

export default __exports__